import { Offers } from "@/models/scope/productSheet/offer/Offers";
import { OfferItem } from "@/models/scope/productSheet/offer/OfferItem";
import { ThunkResult } from "@/models/common/core/ThunkResult";
import { OFFERS_DATA_FETCHED_TYPE } from "@/redux/reducers/responsive/product/marketplaceTypes";
import { OFFERS_DATA_FETCHED } from "@/redux/reducers/responsive/actionsTypes";
import { getOffersDataByEan } from "@/services/marketPlaceServices";

export const fetchOffersData = (ean: string): ThunkResult<OFFERS_DATA_FETCHED_TYPE> => (dispatch) =>
    getOffersDataByEan(ean)
        .then((data: Offers) => {
            let newOffers: OfferItem[] = [];
            let reconditionnedOffers: OfferItem[] = [];
            data.items.map((item: OfferItem) => {
                if (item.state === "new") {
                    newOffers.push(item);
                } else {
                    reconditionnedOffers.push(item);
                }
            })
            dispatch({
                type: OFFERS_DATA_FETCHED,
                payload: {
                    offersData: data,
                    newOffers: newOffers,
                    reconditionnedOffers: reconditionnedOffers,
                    winningOffer: data.items[data.winningOfferIndex].offerId == 0
                        ? data.items[data.winningOfferIndex + 1]
                        : data.items[data.winningOfferIndex]
                }
            });
        })
        .catch((error) => {
            // TODO AMB check if we should add action in case of error!
            console.log(error);
        });